import vars from '../vars';

$(document).ready(function() {

	// vars.$asidePeriodPrevInput.on('click', function() {
	//     $(window).off('resize');
	// });

	// vars.$asidePeriodNextInput.on('click', function() {
	//     $(window).off('resize');
	// });
});


// WEBPACK FOOTER //
// ./src/js/general/aside-inputs.js